import {MonitorReducer, ReducerFromState} from "../../../@types/reducers";
import {MonitorSettingsObject} from "../../../@types/response";

export const getSettings = (state: ReducerFromState<MonitorReducer>): MonitorSettingsObject => state.monitor.settings;